<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!verificarPermissao('PERM_LISTAR_CANAL_DE_INDICACAO')">
            <div style="text-align: center;">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="verificarPermissao('PERM_LISTAR_CANAL_DE_INDICACAO')">
            <div class="formgroup" *ngIf="verificarPermissao('PERM_INSERIR_CANAL_DE_INDICACAO')">
                <div class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-2">
                        <button pButton pRipple label="Novo" routerLink="/apps/suporte/inserir" icon="pi pi-plus"
                            class="p-button-outlined sm:w-9rem"></button>
                    </div>
                </div>
            </div>
            <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
            </div>
            <p-table #dt1 [value]="pageChamados.content" dataKey="id"
                [rows]="pageChamados.size" [paginator]="true"
                [totalRecords]="pageChamados.totalElements" 
                [lazy]="true"
                [loading]="loading"
                [rowHover]="true"
                (onLazyLoad)="onLazyLoad($event)"
                [showCurrentPageReport]="true"
                styleClass="p-datatable-gridlines"
                responsiveLayout="stack" styleClass=" p-datatable-sm"
                currentPageReportTemplate="Mostrando {first} ao {last} de {totalRecords} registros">
                <ng-template pTemplate="caption">
                    <div class="flex justify-content-between flex-column sm:flex-row">
                        <div class="flex flex-column sm:flex-row">
                            <div class="p-fluid sm:mr-2">
                                <label>Solicitação</label>
                                <p-dropdown [options]="listaFiltroSolicitado"
                                    optionLabel="label" optionValue="value" emptyFilterMessage="Nenhum registro"
                                    name="solicitadoFiltro" ngModel #solicitadoFiltro="ngModel" placeholder="Selecione"
                                    [(ngModel)]="solicitadoSelecionado" (onChange)="alterarFiltro(dt1)">
                                </p-dropdown>
                            </div>
                            <div class="p-fluid mt-2 sm:mt-0 sm:mr-2">
                                <label>Situação</label>
                                <p-dropdown [options]="listaStatus" optionLabel="label" optionValue="value"
                                    emptyFilterMessage="Nenhum registro" name="situacao" ngModel #situacao="ngModel"
                                    placeholder="Selecione" [(ngModel)]="statusSelecionado"
                                    (onChange)="alterarFiltro(dt1)">
                                </p-dropdown>
                            </div>

                        </div>

                        <div class="p-fluid mt-2 sm:mt-4">
							<div class="flex">
								<span class="p-input-icon-left">
									<i class="pi pi-search"></i>
									<input pInputText type="text" [(ngModel)]="inputBusca" (input)="buscar(dt1, $event)"
                                     placeholder="Buscar" class="w-full" />
								</span>
								<span class="ml-2">
									<button pButton class="p-button-outlined" icon="pi pi-filter-slash"
										pTooltip="Limpar Filtros" (click)="limpar(dt1)"></button>
								</span>
							</div>
						</div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th>
                            Protocolo
                        </th>
                        <th>
                            Data
                        </th>
                        <th>
                            Situação
                        </th>
                        <th>
                            Solicitado
                        </th>
                        <th>
                            Ações
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>
                            {{item.protocolo}}
                        </td>
                        <td>
                            {{item.dataCriacao | date:'dd/MM/yyyy HH:mm:ss'}}
                        </td>
                        <td>
                            {{item.statusFormatado }}
                        </td>
                        <td>
                            {{item.solicitado}}
                        </td>
                        <td>
                            <button pButton class="p-button-primary" icon="pi pi-comments" pTooltip="Acessar conversa"
                                (click)="redirecionarPagina('/apps/suporte/chat/' + item.id)">
                            </button>
                        </td>
                    </tr>

                </ng-template>
                <ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">Nenhum registro encontrado.</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="loadingbody">
					<tr>
						<td colspan="7">Carregando. Por favor aguarde.</td>
					</tr>
				</ng-template>
            </p-table>
        </div>
    </div>
</div>